import { render, staticRenderFns } from "./version.vue?vue&type=template&id=73a6e70c&scoped=true&"
import script from "./version.vue?vue&type=script&lang=js&"
export * from "./version.vue?vue&type=script&lang=js&"
import style0 from "./version.vue?vue&type=style&index=0&id=73a6e70c&prod&lang=scss&"
import style1 from "./version.vue?vue&type=style&index=1&id=73a6e70c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6e70c",
  null
  
)

export default component.exports